import { render, staticRenderFns } from "./RoomBoard.vue?vue&type=template&id=24b76b04&scoped=true&"
import script from "./RoomBoard.vue?vue&type=script&lang=js&"
export * from "./RoomBoard.vue?vue&type=script&lang=js&"
import style0 from "./RoomBoard.vue?vue&type=style&index=0&id=24b76b04&lang=scss&scoped=true&"
import style1 from "./RoomBoard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b76b04",
  null
  
)

export default component.exports